import { render, staticRenderFns } from "./CrearMensajeModal.vue?vue&type=template&id=db6213e6&"
import script from "./CrearMensajeModal.vue?vue&type=script&lang=ts&"
export * from "./CrearMensajeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports